import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DattaConfig } from '../app-config';
import { ThongtindetaiLinhVuc } from '../model/thongtindetai/thongtindetailinhvuc';
import { ThongtindetaiCoquanchutri } from '../model/thongtindetai/thongtindetaicoquanchutri';
import { ThongtinDetai } from '../model/thongtindetai/thongtindetai';


@Injectable({
  providedIn: 'root'
})
export class ThongtindetaiService {
  public dattaConfig: any;
  token: string;

  httpOptions: any;
  constructor(private httpClient: HttpClient) {
    this.dattaConfig = DattaConfig.config;  
  }
  
  ngOnInit(): void {
  }

  //start Linhvuc
  getThongtindetaiLinhVucs() {
    return this.httpClient.get<ThongtindetaiLinhVuc[]>(this.dattaConfig['httplink'] + '/thongtindetailinhvuc');
  }

  addThongtindetaiLinhVuc(entity: ThongtindetaiLinhVuc) {
    return this.httpClient.post<ThongtindetaiLinhVuc>(this.dattaConfig['httplink'] + '/thongtindetailinhvuc/add', entity);
  }

  updateThongtindetaiLinhVuc(entity: ThongtindetaiLinhVuc){
    return this.httpClient.put<ThongtindetaiLinhVuc>(this.dattaConfig['httplink'] + '/thongtindetailinhvuc/update', entity);
  }

  deleteThongtindetaiLinhVuc(id) {
    return this.httpClient.delete<ThongtindetaiLinhVuc>(this.dattaConfig['httplink'] + '/thongtindetailinhvuc/'+id);
  }
  //end Linhvuc

  //start Coquanchutri
  getThongtindetaiCoquanchutris() {
    return this.httpClient.get<ThongtindetaiCoquanchutri[]>(this.dattaConfig['httplink'] + '/thongtindetaicoquanchutri');
  }

  addThongtindetaiCoquanchutri(entity: ThongtindetaiCoquanchutri) {
    return this.httpClient.post<ThongtindetaiCoquanchutri>(this.dattaConfig['httplink'] + '/thongtindetaicoquanchutri/add', entity);
  }

  updateThongtindetaiCoquanchutri(entity: ThongtindetaiCoquanchutri){
    return this.httpClient.put<ThongtindetaiCoquanchutri>(this.dattaConfig['httplink'] + '/thongtindetaicoquanchutri/update', entity);
  }

  deleteThongtindetaiCoquanchutri(id) {
    return this.httpClient.delete<ThongtindetaiCoquanchutri>(this.dattaConfig['httplink'] + '/thongtindetaicoquanchutri/'+id);
  }
  //end Coquanchutri

  //start Detai
  getThongtinDetais() {
    return this.httpClient.get<ThongtinDetai[]>(this.dattaConfig['httplink'] + '/thongtindetai');
  }

  getThongtinDetaiTheodonvis(id) {
    return this.httpClient.get<ThongtinDetai[]>(this.dattaConfig['httplink'] + '/thongtindetai/'+id);
  }

  addThongtinDetai(entity: ThongtinDetai) {
    return this.httpClient.post<ThongtinDetai>(this.dattaConfig['httplink'] + '/thongtindetai/add', entity);
  }

  updateThongtinDetai(entity: ThongtinDetai){
    return this.httpClient.put<ThongtinDetai>(this.dattaConfig['httplink'] + '/thongtindetai/update', entity);
  }

  deleteThongtinDetai(id) {
    return this.httpClient.delete<ThongtinDetai>(this.dattaConfig['httplink'] + '/thongtindetai/'+id);
  }
  //end Detai
  
}